import React from 'react';
import './sport.css'
import { useEffect, useState } from 'react';
import Sports from '../Sports/Sports';


const Sport = () => {

    const [ leagues, setLeauges ] = useState([]);
    useEffect(() => {
    const url = 'https://www.thesportsdb.com/api/v1/json/1/lookup_all_teams.php?id=4328';
    fetch(url)
    .then(res => res.json())
    .then(data=> setLeauges(data.teams))
  }, [])
    return (
        <div>
            <div className="top-banner">
                <h1>Premier League</h1>
            </div>
            <div className="container"> 
            {
                leagues.map(sports => <Sports sports={sports}></Sports>)
            }
            </div>
        </div>
    );
};

export default Sport;